module.exports = __webpack_public_path__ + "static/img/logo.2896f3f0.png";